<template>
    <v-button @click.native="rotateIcon" no-caps dense outline rounded color="primary" class="btn-language" :class="!isMobile ? 'uppercase': ''">
        <img v-if="flags" :src="currentFlag" class="avatar tb-icon-square no-shadow">
        {{ isMobile ? currentLocaleName : locale }}
        <q-icon :class="rotate ? 'rotate' : 'not-rotate'" class="q-ml-sm" name="fa icon-chevron-down"></q-icon>
        <q-popover>
            <q-list dense link class="flags">
                <q-item v-for="(localeName, localeKey) in locales" :key="localeKey"
                        v-close-overlay @click.native="setLocale(localeKey)">
                    {{ localeName }}
                    <q-item-side v-if="locale == localeKey" right icon="done" />
                </q-item>
            </q-list>
        </q-popover>
    </v-button>
</template>

<style lang="stylus">
    @import "../../stylus/_variables.styl"

    .flags
        .q-item-avatar
            width $toolbar-icon-height !important
            height $toolbar-icon-height !important

        .q-item-side
            height $toolbar-icon-height !important
</style>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'
    import {
        QPopover,
        QList,
        QItem,
        QItemSide
    } from 'quasar-framework'

    export default {
        props: {
            flags: Boolean
        },

        computed: {
            ...mapGetters({
                locale: 'lang/locale',
                locales: 'lang/locales',
            }),
            currentFlag() {
                return this.flagFor(this.locale)
            },
            currentLocaleName() {
                return this.localNameFor(this.locale)
            }
        },

        data(){
            return {
                isMobile: false,
                rotate: false
            }
        },

        components: {
            QPopover,
            QList,
            QItem,
            QItemSide
        },

        mounted(){
            this.isMobile = this.$q.platform.is.mobile
        },

        methods: {
            setLocale (locale) {
                if (this.$i18n.locale !== locale) {
                    loadMessages(locale)

                    this.$store.dispatch('lang/setLocale', {locale})
                    this.rotateIcon()
                }
            },
            flagFor (locale) {
                return `${config.appUrl}${config.devAssetsFolder}/img/locale/${locale}.svg`
            },
            rotateIcon(){
                this.rotate = !this.rotate
            },
            localNameFor(locale) {
                return this.locales[locale]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LocaleDropdown.vue